import { AccordionButton, Box, Flex, Heading, useAccordionContext, } from '@chakra-ui/react';
import React from 'react';
import Chevron, { ChevronDirection } from '../../icons/Chevron';
const VerticalAccordionTitle = (props) => {
    const { index } = useAccordionContext();
    return (React.createElement(Heading, null,
        React.createElement(AccordionButton, null,
            React.createElement(Flex, { width: "100%" },
                React.createElement(Box, { flexGrow: 1, textAlign: "left" },
                    React.createElement(Heading, { as: "h2", variant: "lt-500-lt-5" }, props.children)),
                React.createElement(Box, null,
                    React.createElement(Chevron, { direction: index ? ChevronDirection.DOWN : ChevronDirection.UP }))))));
};
export default VerticalAccordionTitle;
